export default __webpack_public_path__ + "static/media/10d.7ee353d9.svg";